// @flow

import React, { PureComponent } from "react";
import styled, { keyframes } from "styled-components";
import buildColor from "../ColorPalette";

const pulseAnimation = keyframes`
  0% {
    fill: ${buildColor("grey", "100")};
  }

  50% {
    fill: ${buildColor("grey", "000")};
  }

  100% {
    fill: ${buildColor("grey", "100")};
  }
`;

const SVG = styled.svg`
  display: block;
  width: 100%;
  height: 176px;
  background: ${buildColor("white", "100")};
  margin-bottom: 8px;

  rect.pulse {
    animation: ${pulseAnimation} 1.25s infinite;
  }
`;

const MaskContainer = styled.div`
  height: 100%;
  width: 100%;
  background: ${buildColor("grey", "100")};
`;

const smallSvg = () => (
  <SVG>
    <g>
      <path fill={buildColor("white", "100")} d="M0 0h375v176H0z" />
      <rect
        className="pulse"
        width="20"
        height="20"
        x="12"
        y="143"
        fill={buildColor("grey", "000")}
        rx="1"
      />
      <rect
        className="pulse"
        width="100"
        height="8"
        x="110"
        y="115"
        fill={buildColor("grey", "000")}
        rx="1"
      />
      <rect
        className="pulse"
        width="40"
        height="8"
        x="110"
        y="99"
        fill={buildColor("grey", "000")}
        rx="1"
      />
      <rect
        className="pulse"
        width="52"
        height="8"
        x="12"
        y="115"
        fill={buildColor("grey", "000")}
        rx="1"
      />
      <rect
        className="pulse"
        width="72"
        height="8"
        x="12"
        y="99"
        fill={buildColor("grey", "000")}
        rx="1"
      />
      <rect
        className="pulse"
        width="48"
        height="8"
        x="12"
        y="59"
        fill={buildColor("grey", "000")}
        rx="1"
      />
      <rect
        className="pulse"
        width="112"
        height="8"
        x="12"
        y="43"
        fill={buildColor("grey", "000")}
        rx="1"
      />
      <rect
        className="pulse"
        width="36"
        height="16"
        x="12"
        y="12"
        fill={buildColor("grey", "000")}
        rx="1"
      />
    </g>
  </SVG>
);

const bigSvg = () => (
  <SVG>
    <g>
      <path fill={buildColor("white", "100")} d="M0 0h375v176H0z" />
      <rect
        className="pulse"
        width="20"
        height="20"
        x="12"
        y="143"
        fill={buildColor("grey", "000")}
        rx="1"
      />
      <rect
        className="pulse"
        width="20"
        height="20"
        x="36"
        y="143"
        fill={buildColor("grey", "000")}
        rx="1"
      />
      <rect
        className="pulse"
        width="20"
        height="20"
        x="60"
        y="143"
        fill={buildColor("grey", "000")}
        rx="1"
      />
      <rect
        className="pulse"
        width="100"
        height="8"
        x="110"
        y="115"
        fill={buildColor("grey", "000")}
        rx="1"
      />
      <rect
        className="pulse"
        width="40"
        height="8"
        x="110"
        y="99"
        fill={buildColor("grey", "000")}
        rx="1"
      />
      <rect
        className="pulse"
        width="52"
        height="8"
        x="12"
        y="115"
        fill={buildColor("grey", "000")}
        rx="1"
      />
      <rect
        className="pulse"
        width="40"
        height="8"
        x="12"
        y="99"
        fill={buildColor("grey", "000")}
        rx="1"
      />
      <rect
        className="pulse"
        width="48"
        height="8"
        x="12"
        y="59"
        fill={buildColor("grey", "000")}
        rx="1"
      />
      <rect
        className="pulse"
        width="176"
        height="8"
        x="12"
        y="43"
        fill={buildColor("grey", "000")}
        rx="1"
      />
      <rect
        className="pulse"
        width="36"
        height="16"
        x="12"
        y="12"
        fill={buildColor("grey", "000")}
        rx="1"
      />
    </g>
  </SVG>
);

export default class MyBetsMask extends PureComponent<*> {
  render() {
    return (
      <MaskContainer data-qa-label="myBetsMask">
        {bigSvg()}
        {smallSvg()}
        {bigSvg()}
      </MaskContainer>
    );
  }
}
